import { makePersisted } from "@solid-primitives/storage";
import { createMemo, createSignal } from "solid-js";

// TODO: Re-enable once we fix wire dependency for landing page
// import { useIsStorytellerEmail } from "~/hooks/useIsStorytellerEmail";

const USER_MODE_STORAGE_KEY = "storytell-user-mode";

export type UserMode = "regular" | "advanced";

/** Persisted signal: null means "use default based on email". */
const [storedUserMode, setStoredUserMode] = makePersisted(createSignal<UserMode | null>(null), {
  storage: typeof window !== "undefined" ? localStorage : undefined,
  name: USER_MODE_STORAGE_KEY,
});

/**
 * User Mode preference: "Regular" or "Advanced".
 * - Non-@storytell.ai users default to "Regular".
 * - @storytell.ai users default to "Advanced".
 * - Any user can override by choosing the other option; choice is persisted.
 * Advanced mode enables features like the "Share this draft prompt" button in the prompt bar.
 */
export const useUserMode = () => {
  // TODO: Fix this properly - useIsStorytellerEmail requires WireProvider which isn't available on landing page
  // For now, default to "advanced" when no stored preference and skip the email check
  // const isStorytellerEmail = useIsStorytellerEmail();

  const userMode = createMemo((): UserMode => {
    const stored = storedUserMode();
    if (stored !== null) return stored;
    // Default to advanced instead of checking email (which requires wire)
    return "advanced";
  });

  const setUserMode = (mode: UserMode) => {
    setStoredUserMode(mode);
  };

  const isAdvanced = createMemo(() => userMode() === "advanced");

  return {
    userMode,
    setUserMode,
    isAdvanced,
  };
};
